import React from 'react';
import type { AnnouncementCard } from '@/cmsBackend/transformers/types/featureAnnouncement';
import {
  CONTAINER_OPTIONS,
  MODULE_FILL_TYPE_OPTIONS,
  MODULE_FLOW_DIRECTION_OPTIONS,
} from '@/common/constants';
import { useModuleStyles } from '@/common/hooks/useModuleStyles';
import styles from './OtherImprovementsSection.module.scss';

export interface OtherImprovementsSectionProps {
  heading: string;
  items: AnnouncementCard[];
}

export const OtherImprovementsSection: React.FC<OtherImprovementsSectionProps> = ({
  heading,
  items,
}) => {
  const { sectionStyles, moduleBaseStyles } = useModuleStyles({
    container: CONTAINER_OPTIONS.UNCONTAINED,
    fillType: MODULE_FILL_TYPE_OPTIONS.BASE,
    flowDirection: MODULE_FLOW_DIRECTION_OPTIONS.COLUMN,
    moduleClassName: 'module-other-improvements',
    styles,
  });

  if (!items.length) return null;

  return (
    <section className={sectionStyles}>
      <div className={moduleBaseStyles}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src="https://images.ctfassets.net/cocwkk0wzcrd/27PIlMeCB4n3ezpDriAyeJ/80b428b5f633485bcd31b4f18894c1fe/cowboy.png"
          alt=""
          className={styles.section__illustration}
          loading="lazy"
          aria-hidden="true"
        />
        <div className={styles.section__header}>
          <span className={styles.section__badgePink}>{heading}</span>
        </div>
        <ol className={styles.section__list}>
          {items.map((item) => (
            <li key={item.id} className={styles.section__item}>
              <div className={styles.section__itemHeading}>
                <p className={styles.section__itemDate}>{item.date}</p>
                <h3 className={styles.section__itemTitle}>{item.title}</h3>
              </div>
              <p className={styles.section__itemSummary}>{item.summary}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
